import { render, staticRenderFns } from "./ReadIslander.vue?vue&type=template&id=2eca8a72&"
import script from "./ReadIslander.vue?vue&type=script&lang=ts&"
export * from "./ReadIslander.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports